<template>
    <div v-if="!state.loading">
        <div class="pgehd">
            <h2>Submission for {{title}}</h2>
        </div>
        
        <PrimeDataTable
            :value="list"
            :rows="10"
            responsiveLayout="scroll"
            stripedRows>
            
            <PrimeColumn field="sn" header="sn" />
            <PrimeColumn field="name" header="Name" />
            <PrimeColumn field="status" header="Status" />
            <PrimeColumn field="score" header="Score" />
            <PrimeColumn header="Options">
                <template #body="slotProps">
                    <div class="flex gap-2">
                        <PrimeButton
                            v-if="slotProps.data.status !='Outstanding'"
                            label="Answers"
                            icon="pi pi-bars"
                            class="p-button-rounded p-button-text"
                            @click="answers(slotProps.data)"
                        />
                    </div>
                </template>
            </PrimeColumn>
        </PrimeDataTable>
    </div>
    <div v-else class="loader">
        <img src="@/assets/img/ajldr.gif" />
    </div>
</template>
<script>
import call from "../composables/call.js";
import { urls } from "../assets/js/urls.js";
import { onMounted, reactive, ref, computed} from 'vue';
import { useRouter, useRoute } from "vue-router";

export default {
    name:"AssignmentSubmission",
    setup(){
        const route = useRoute();
        const router = useRouter();
        const id = computed(() => route.params.id)
        const state=reactive({loading:true})
        const list = ref([])
        const globalFilter=ref("")
        const title=ref("")
        onMounted(() => {
            call({
                url:urls.subject,
                data:{getSubmissionList:id.value},
                success:(res)=>{
                    state.loading=false
                    if(res.status){
                        title.value=res.msg.title;
                        if (!Array.isArray(res.msg.list)) {
                            list.value = Object.values(res.msg.list)
                        } else {
                            list.value = res.msg
                        }
                    }else{
                        alert(res.msg);
                    }
                }
            })
        });

        function answers(row){
            router.push({ name: 'markassignment', params: { stu: row.stu_id, id: id.value} });
        }
        
        return {list,globalFilter, state,title,answers}
    }
}
</script>